import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            暴走黑料在线观看与黑料社在线观看全系列专题索引
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {indexItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 right-3">
                  <span className="inline-block px-2.5 py-1 bg-background-950/70 text-background-50 text-xs font-semibold rounded-md">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center text-xs text-primary-500 font-medium">
                  <span className="whitespace-nowrap">查看全部</span>
                  <i className="ri-arrow-right-line ml-1 transition-transform duration-300 group-hover:translate-x-1"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}